import { render, staticRenderFns } from "./KoutsuhiListPage.vue?vue&type=template&id=56f33394&scoped=true&"
import script from "./KoutsuhiListPage.vue?vue&type=script&lang=ts&"
export * from "./KoutsuhiListPage.vue?vue&type=script&lang=ts&"
import style0 from "./KoutsuhiListPage.vue?vue&type=style&index=0&id=56f33394&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f33394",
  null
  
)

export default component.exports